import * as React from "react";
const SvgInfoIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M50,4.7A45.3,45.3,0,1,0,95.3,50,45.3,45.3,0,0,0,50,4.7Zm4.48,67.8h-9v-27h9Zm0-36h-9v-9h9Z" }));
export default SvgInfoIcon;
